module.exports = __webpack_public_path__ + "static/media/extension_icon.9b7f9b17.svg";